<script>
/**
 * Footer Component
 */
export default {}
</script>

<template>
    <!-- Footer Start -->
    <footer class="footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    2025 &copy; 法語鸚鵡螺 by <a href="https://jbravo.com.tw">嵩鴻數位有限公司</a>
                </div>
            </div>
        </div>
    </footer>
    <!-- end Footer -->
</template>
